import { CampaignStatistics } from "../../../models/Statistics";

export const REQUEST_CAMPAIGNSTATISTICS = "REQUEST_CAMPAIGNSTATISTICS";
export const REQUEST_CAMPAIGNSTATISTICS_DONE =
  "REQUEST_CAMPAIGNSTATISTICS_DONE";

export interface FetchCampaignStatistics {
  type: typeof REQUEST_CAMPAIGNSTATISTICS;
  payload: ReadonlyArray<CampaignStatistics>;
}

export interface FetchCampaignStatisticsDone {
  type: typeof REQUEST_CAMPAIGNSTATISTICS_DONE;
  payload: ReadonlyArray<CampaignStatistics>;
}

export interface CampaignsStatisticsState {
  isLoading: boolean;
  campaignStatistics: ReadonlyArray<CampaignStatistics>;
}

export type CampaignStatisticsActions =
  | FetchCampaignStatistics
  | FetchCampaignStatisticsDone;
